export default {
  'family:box': {
    outer: '$reset',
    label: '$reset',
    inner: '$reset',
    input: '$reset',
  },
  'family:button': {
    label: '$reset formkit-label',
    inner: '$reset formkit-inner',
    input: `
      $reset \
      formkit-input \
      flex \
      justify-center \
      items-center \
      gap-[6px] \
      border-0 \
      min-w-[128px] \
      w-full \
      rounded-[4px] \
      cursor-pointer \
      focus-within:border-focus \
      focus-within:ring-2 \
      focus-within:ring-blue-400 \
      px-[16px] \
      py-[12px] \
      leading-[24px] \
      group-data-[disabled]:bg-inactive \
      group-data-[disabled]:text-dark \
      group-data-[disabled]:cursor-not-allowed \
    `,
  },
}
